var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M24,0A24,24,0,1,1,0,24,24,24,0,0,1,24,0Z",
    fill: "#0c1c4b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(14 17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M7,14a1,1,0,0,1-.707-.293l-6-6A1,1,0,0,1,1.707,6.293L7,11.586,18.293.293a1,1,0,0,1,1.414,1.414l-12,12A1,1,0,0,1,7,14",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleSelected);
export default __webpack_public_path__ + "static/media/check-circle-selected.4c26416819514eb282847859a28b75f8.svg";
export { ForwardRef as ReactComponent };